var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('frame-surface-opening-side'),_c('v-divider',{staticClass:"my-5"}),_c('frame-surface-counter-opening-side'),_c('v-divider',{staticClass:"my-5"}),_c('frame-surface-gloss'),_c('v-divider',{staticClass:"my-5"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }